import { render, staticRenderFns } from "./user_project_create_data_query.vue?vue&type=template&id=cab81a0a"
import script from "./user_project_create_data_query.vue?vue&type=script&lang=js"
export * from "./user_project_create_data_query.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports